import React from "react";
import { styled } from "@mui/system";
import MUIPaper, { PaperProps } from "@mui/material/Paper";

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    menuItem: true;
  }
}

export const Paper = styled((props: PaperProps) => <MUIPaper {...props} />, {
  name: "Paper",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiPaper-root": {
    background: theme.palette.primary.surfaceDefault,
    margin: "24px 16px",
    boxShadow: theme.shadows[4],
  },
}));
